import NetworkCall from "network/networkCall";
import Request from "network/request";
import {
  camelCaseKeysRecursively,
  camelCaseKeys,
} from "utilities/generalUtility";

export default class Class {
  static async getClassDetailById(classId) {
    const res = await NetworkCall.fetch(Request.getClassDetailById(classId));
    return camelCaseKeysRecursively(res.data);
  }

  static async addClientClass(clientId) {
    const res = await NetworkCall.fetch(Request.addClientClass(clientId));
    return camelCaseKeysRecursively(res.data);
  }

  static async getClientClass(clientId) {
    const res = await NetworkCall.fetch(Request.getClientClassList(clientId));
    return camelCaseKeysRecursively(res.data);
  }

  static async getSettings(classId) {
    const res = await NetworkCall.fetch(Request.getClassSettings(classId));
    return camelCaseKeysRecursively(res.data);
  }

  static async updateSettings(values) {
    const res = await NetworkCall.fetch(Request.updateClassSettings(values));
    return camelCaseKeysRecursively(res.data);
  }

  static async getStatistics(id) {
    const res = await NetworkCall.fetch(Request.getClassStatistics(id));
    return camelCaseKeys(res.data);
  }

  static async updateClassStatus(body) {
    await NetworkCall.fetch(Request.updateClassStatusById(body));
  }

  static async getSubStatusBreakdown(classId) {
    const res = await NetworkCall.fetch(
      Request.getClassSubStatusBreakdown(classId),
    );
    return camelCaseKeysRecursively(res.data);
  }
}
